import {LIMPAR_ULTIMOS_HISTORICOS_ROTA} from '../types';

export default function limparUltimosHIstoricosRota () {
    return {
        type: LIMPAR_ULTIMOS_HISTORICOS_ROTA
    }
}
